import React from 'react';
import GMap from './SearchMap/map.js';
import { tokenize } from '../../front/search-query';
import { Provider } from 'react-redux';
import createStore from './SearchMap/store';
import Actions from "./SearchMap/actions";
import additionalfn from '../../_additionalfn';

export class SearchMap extends React.Component  {
    constructor(props) {
        super(props);
        
        this.state = {
            store: createStore({
                villas: this.props.villas,
                clusters: this.props.clusters,
                filters : tokenize(this.props.query),
                villaData: null,
                showBlock: false, 
                villaRef: null,
                isChanging: false,
                currentMarkerSelected: null
            })
        }; 
    }
    
    componentDidUpdate(prevProps){
        if (this.props.villas !== prevProps.villas || this.props.filters !== prevProps.filters){
            var store = this.state.store;
        
            store.dispatch(Actions.updateSearch({
                villas: this.props.villas,
                clusters: this.props.clusters,
                filters: tokenize(this.props.query),
                center: additionalfn.getCenterFromLatLng(this.props.villas)
            }));
            
            this.setState({
                store: store
            });
        }
    }
    
    render(){ 
        return(
            <Provider store={this.state.store}>
            <div>
                <GMap 
                    key="villasMap"
                />
            </div>
            </Provider>
        );
    }
}